import React, { useEffect } from "react";
import { Image } from 'react-bootstrap';

import { getScrollbarWidth, useMainContentWidth } from "utils/ScreenUtil";
import { useFormContext } from "react-hook-form";
import './TypeSelector.scss';

const WIDTH = 330;
const SPACE_BETWEEN = 30;

const SingleItem = ({
  item,
  onClick,
  selected,
  customItemClassName = "",
  disabled=false,
}) => {
  return (
    <div
      key={`${item.id}-${item.description}`}
      className={
        `type-selector-single-item-container ${customItemClassName} ${
          item.id === selected ? "selected" : ""} ${disabled ? "disabled" : ""}`
      }
      onClick={() => {
        if (disabled) {
          return
        }
        onClick(item.id);
      }}
    >
      <div className="type-selector-name-with-description">
        <label className="type-selector-name">{item.title}</label>
        <label className="type-selector-description">{item.description}</label>
      </div>
      <Image className={`type-selector-image ${item.imageClassName}`} src={item.image} />
    </div>
  );
}

const TypeSelector = ({
  title = "",
  typeFieldName = "type",
  defaultValue,
  typeConfig = [],
  customItemClassName = "",
  itemWidth = WIDTH,
  extraAction = () => {},
  disabled = false,
}) => {
  const mainContentWidth = useMainContentWidth();
  const fullContainerWith = mainContentWidth - 80 - 60 - getScrollbarWidth();
  const {
    watch,
    setValue,
  } = useFormContext();
  const watchType = watch(typeFieldName)

  useEffect(() => {
    if (!watchType && defaultValue) {
      setValue(typeFieldName, defaultValue, { shouldDirty: true });
    }
  }, [watchType, defaultValue])

  return (
    <>
      {title && <div className="type-selector-title">{title}</div>}
      <div
        className={`type-selector-container ${disabled ? " disabled" : ""}`}
        style={{
          justifyContent:
            fullContainerWith < (itemWidth + SPACE_BETWEEN) * 2
              ? 'center'
              : 'flex-start',
        }}
      >
        {typeConfig.map((typeItem, idx) => (
          <SingleItem
            key={`${idx}-${typeItem.id}`}
            item={typeItem}
            selected={watchType}
            disabled={disabled && typeItem.id === watchType}
            onClick={(id) => {
              if (disabled) {
                return
              }
              if (watchType === id) {
                return;
              }
              setValue(typeFieldName, id, { shouldDirty: true });
              extraAction(id);
            }}
            customItemClassName={customItemClassName}
          />
        ))}
      </div>
    </>
  )
}

export default TypeSelector;
